import { Link } from 'react-router-dom';

import cn from 'classnames';
import useCourseImportScreen from 'hooks/use-course-import';
import { ROUTES } from 'routes';

import { ReactComponent as LogoutIcon } from 'assets/logout_active.svg';

import Course from './Course';

interface StepsProps {
  activeScreenIndex: number;
  gotoScreenIndex: (screen: number) => void;
  totalScreens: number;
  screenLabels: string[];
}

const Steps = ({ activeScreenIndex, gotoScreenIndex, totalScreens, screenLabels }: StepsProps) => {
  const handleStep = (stepIndex: number) => () => {
    if (stepIndex >= activeScreenIndex) return;
    gotoScreenIndex(stepIndex);
  };

  return (
    <nav className='import-course-root__nav'>
      <ul className='nav'>
        {new Array(totalScreens).fill(<div />).map((_, index) => (
          <li key={index}>
            <button
              className={cn('nav__item', {
                'nav__item--disabled': index > activeScreenIndex,
                'nav__item--active': index === activeScreenIndex,
              })}
              onClick={handleStep(index)}
              disabled={index > activeScreenIndex}
            >
              {`Step ${index + 1}: ${screenLabels[index]}`}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

const ImportCourse = () => {
  const { activeScreen, activeScreenIndex, goto, gotoIndex, onPrev, onNext, totalScreens, screenLabels } =
    useCourseImportScreen();

  return (
    <div className='import-course-root'>
      <Steps
        activeScreenIndex={activeScreenIndex}
        gotoScreenIndex={gotoIndex}
        totalScreens={totalScreens}
        screenLabels={screenLabels}
      />
      <nav className='import-course-root__other-actions'>
        <ul className='nav'>
          <li>
            <Link className='nav__item' to={ROUTES.LOG_OUT}>
              <LogoutIcon className='nav__icon' /> Log Out
            </Link>
          </li>
        </ul>
      </nav>
      <Course
        className='import-course-root__body'
        activeScreen={activeScreen}
        goto={goto}
        onPrev={onPrev}
        onNext={onNext}
      />
    </div>
  );
};

export default ImportCourse;
